"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Youtube = function Youtube(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className),
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 24 24",
    height: "24",
    width: "24"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(1,0,0,1,0,0)",
    stroke: fill,
    fill: "none",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 5,12.25h14c2.209,0,4,1.791,4,4v3c0,2.209-1.791,4-4,4H5c-2.209,0-4-1.791-4-4v-3 C1,14.041,2.791,12.25,5,12.25z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 4,0.75l3,4v4.5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 10,0.75l-3,4v4.5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 13,7.75c0,0.828-0.672,1.5-1.5,1.5S10,8.578,10,7.75v-3 c0-0.828,0.672-1.5,1.5-1.5S13,3.922,13,4.75V7.75z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 19,3.25v4c0,1.105-0.895,2-2,2s-2-0.895-2-2v-4"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 19,3.25v6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 11,17v3.25"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 3.98,15.25h4.04"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 6,15.25v4.98"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 13.5,14.25v5.98"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 15.5,19.25c0,0.552-0.448,1-1,1s-1-0.448-1-1V18c0-0.552,0.448-1,1-1 s1,0.448,1,1V19.25z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 9,17v2.25c0,0.552,0.448,1,1,1s1-0.448,1-1V17"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 18.83,16.75c0.552,0,1,0.448,1,1h-2"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 19.83,19.86 c-0.413,0.475-1.133,0.525-1.608,0.112c-0.247-0.215-0.389-0.525-0.392-0.852v-1.37c0-0.552,0.448-1,1-1"
  })));
};
Youtube.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Youtube.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Youtube;